import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';

import PageWrapper from '../../components/PageWrapper';
import CTAComponent from '../../components/CTAComponent';
import HomeHeader from './HomeHeader';
import HomeFeatures from './HomeFeatures';
import HomeDirections from './HomeDirections';
import HomeTour from './HomeTour';
import HomeFloorplans from './HomeFloorplans';
import HomeDetails from './HomeDetails';
import HomeDescription from './HomeDescription';
import HomeVideo from './HomeVideo';

function HomeDetail({ home, community, plan }) {
  return (
    <PageWrapper singlePage>
      <PageHelmet home={home} />
      <HomeHeader home={home} />
      <HomeDetails home={home} plan={plan} community={community} />
      {
        get(home, 'description') &&
        <HomeDescription home={home} />
      }
      {
        get(home, 'floorplanPhotos') && get(home, 'floorplanPhotos').length > 0 &&
        <HomeFloorplans home={home} />
      }
      {
        get(home, 'tourUrl') &&
        <HomeTour home={home} />
      }
      {
        get(home, 'video_url') &&
        <HomeVideo home={home} />
      }
      <HomeDirections home={home} community={community} />
      {
        get(home, 'features') &&
        <HomeFeatures home={home} />
      }
      <CTAComponent type="Home" />
    </PageWrapper>
  );
}

HomeDetail.propTypes = {
  home: PropTypes.object.isRequired,
  community: PropTypes.object.isRequired,
  plan: PropTypes.object,
};

HomeDetail.defaultProps = {
  plan: undefined,
};

export default withData(
  {
    home: true,
    community: true,
    plan: true,
  },
  {
    required: {
      home: true,
    },
    ifMissing404: true,
  },
)(HomeDetail);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/index.js